import usedContentCard, { en as usedContentCardEN, ca as usedContentCardCA } from './usedContentCard'

export default {
  usedContent: 'Registro de uso',
  emptyList: 'No hay registro de uso de este contenido',
  usedContentCard
}

export const en = {
  usedContent: 'Register usage',
  emptyList: 'There is no usage record for this content',
  usedContentCard: usedContentCardEN
}

export const ca = {
  usedContent: 'Registres d\'ús',
  emptyList: 'No hi ha registre dús d\'aquest contingut',
  usedContentCard: usedContentCardCA
}
